import { setAccess } from 'actions/schedule';
import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import ScheduleAdmin from "./scheduleAdmin"
import ScheduleStudent from './ScheduleStudent';
import ScheduleTeacher from './ScheduleTeacher';
import { getSchedulePermissions } from './schedulePermissions';

const Schedule = ({ user, setAccess }) => {
    // ScheduleTeacher shows only the signed-in teacher's own classes; ScheduleAdmin shows
    // every class. The matrix says a Teacher is narrowed to their own classes ONLY while
    // they hold no privilege - Admin, Planner or AttendanceMarker all widen them to the
    // full list - so viewScope, not the role alone, picks the component.
    const permissions = getSchedulePermissions(user);

    // The privilege list below already caught Planner and AttendanceMarker but not a
    // plain 'Admin' privilege, so a Teacher who was made an Admin still landed on the
    // own-classes-only view. permissions.viewScope covers all three uniformly.
    if (user?.access?.includes("schedule-admin") || user?.access?.includes("schedule-superadmin") || user?.access?.includes("schedule-planner") || user?.privilage?.includes("AttendanceMarker") || user?.privilage?.includes("Planner") || user?.isAttendanceMarker || user?.isPlanner || user?.isAdmin || user?.isSuperAdmin
        || (permissions.isTeacher && permissions.hasElevatedPrivilege)) {
        setAccess(true)
        return (
            <div>
                <ScheduleAdmin />
            </div>
        )
    }
    else if (user.access.includes("schedule-teacher")) {
        return (
            <div>
                <ScheduleTeacher />
            </div>
        )
    }
    else if (user.access.includes("schedule-student")) {

        return (
            <div>
                <ScheduleStudent />
            </div>
        )
    }

    else{
         setAccess(false)
        return(
            <div>
                <ScheduleAdmin/>
            </div>
        )
    }

}


const mapStateToProps = (state) => {
    const {
    } = state.schedule;
    const { user } = state.session;
    return {
        user
    };
};

const mapDispatchToProps = (dispatch) => ({
    setAccess : (bool) => dispatch(setAccess(bool))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps

)(Schedule);

